import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './OtherMarketOption.css';
import { useNavigate } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";


function MarketEquity(props) {
    let getOptionOtherMarket = props.optionOtherMarket;
    const { BaseURL } = useContext(URLstateContext);
    const [optionInfo, setOptionInfo] = useState('');
    let navigate = useNavigate();

    useEffect(() => {
        if (optionInfo === "FII Investment") {
            navigate("/OtherMarket/FII-Investment");
        }
        if (optionInfo === "MF Investment") {
            navigate("/OtherMarket/MF-Investment");
        }
        if (optionInfo === "World Indices") {
            navigate("/OtherMarket/World-Indices");
        }
        if (optionInfo === "ADR Prices") {
            navigate("/OtherMarket/ADR-Prices");
        }
        if (optionInfo === "Forex") {
            navigate("/OtherMarket/Forex");
        }
        if (optionInfo === "Overview") {
            navigate("/market/stocks");
        }
    }, [optionInfo]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-scOtherM'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    
                                    {/* aria-label="Select Overview" */}
                                        <select aria-label="Select Overview" value={getOptionOtherMarket} onChange={(event) => { setOptionInfo(event.target.value) }}>
                                            <option value={"Overview"}>Overview</option>
                                            <option value={"FII Investment"}>FII Investment</option>
                                            <option value={"MF Investment"}>MF Investment</option>
                                            <option value={"World Indices"}>World Indices</option>
                                            <option value={"ADR Prices"}>ADR Prices</option>
                                            <option value={"Forex"}>Forex</option>
                                        </select> 
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketEquity;